$ = jQuery;


//Main entrance
document.addEventListener('DOMContentLoaded', function(){

    // get the global variable for signup agents
    

    if( typeof SIGNUP_AGENT !== 'undefined' ) {
        let agent = SIGNUP_AGENT;
        const signup = new AgentSignup( agent );
        signup.agentCard();
        signup.clickEvent();
    }

});



class AgentSignup {

    constructor( _agent ) {
        this.agent = _agent;
    }

    agentCard() {
        let $signupContainer = document.querySelectorAll('.signup-agent-container');
        
        // Return if the agent div is not present
        if( ! $signupContainer ) {
            return
        }

        // Return if no agent is found or being appended
        if ( !this.agent) {
            return
        }

        // Create the agent card html
        let $agentCard = `
            <h3>Your Current Agent: </h3>
            <div id="user-${this.agent.ID}" class="single-team-member-meta mb-4">
                <div class="polaroid-property">
                    <a href="${this.agent.permalink}">
                        <img src="${this.agent.img}" alt="${this.agent.name}" loading="lazy" class="agent-image" />
                    </a>
                    <div class="entry-content author-contact-details p-3">
                        <h4 class="author-title">
                            <a href="${this.agent.permalink}" title="${this.agent.name}">${this.agent.name}</a>
                        </h4>
                        <div class="author-position">
                            <p class="position">${this.agent.position}</p>
                        </div>
                        <div class="" role="toolbar">
                            ${this.agent.phone_html}
                            <div class="btn-group mr-2" role="group">
                                <a href="mailto:${this.agent.email}" type="button" class="btn btn-outline-primary btn-sm mt-2">Email me</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        // add the agent card to the agent container

        $signupContainer.forEach( agent => {
            agent.innerHTML = $agentCard;
        })
        
    }

    clickEvent() {
        let $button = document.querySelectorAll('.gform_next_button');

        $button.forEach( btn => {
            btn.addEventListener( 'click', () => {
                this.formAdjustments();
                this.agentCard(); // try calling agent card again
            });
        })
    }

    formAdjustments() {
        
    }



}
